import { RouterProvider, createRouter } from "@tanstack/react-router";

import { routeTree } from "./routeTree.gen";
import { getContext as getQueryContext } from "./lib/tanstack-query/context";
import { NotFoundErrorPage, RouteErrorFallback } from "./lib/error-boundary";

const { queryClient } = getQueryContext();

const router = createRouter({
	routeTree,
	context: { queryClient },
	defaultPreload: "intent",
	defaultPreloadStaleTime: 0,
	// RouteErrorFallback guards non-Error throws before delegating to
	// RouteErrorComponent; set on the router so every route inherits it.
	defaultErrorComponent: RouteErrorFallback,
	defaultNotFoundComponent: NotFoundErrorPage,
});

declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router;
	}
}

export function App() {
	return <RouterProvider router={router} />;
}
